import React from 'react';
import { Container, Navbar, NavbarBrand } from 'reactstrap';
import { PageTitle } from '@cordata/buffet';

import Identity from '~/assets/identity.svg';

import Form from '~/components/HWC/Form';

const HWC = () => (
  <>
    <Navbar color="primary" dark expand="md" className="mb-3 sticky-top" style={{ height: '56px' }}>
      <NavbarBrand>
        <img src={Identity} width={130} alt="Navigator - Cordata" className="mr-2" />
      </NavbarBrand>
    </Navbar>

    <Container>
      <PageTitle>Handle with Care</PageTitle>

      <Form />
    </Container>
  </>
);

export default HWC;
